import { Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsOutletBlockComponent } from '../outlet-block/icms-outlet-block.component';

@Component({
    selector: 'error-404',
    templateUrl: './error-404.html',
    standalone: true,
    imports: [ICmsOutletBlockComponent]
})
export class Error404Component extends UiComponent {}
